import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './Analysis.css';

const ClarificationPopup = ({ open, highlightedText, clarification, loadingAPI, error, onClose, onRefresh}) => {
    return (
        <Popup open={open} onClose={onClose} modal nested>
            <div className="clarificationModal">
                <div className="contentPopup">
                    <button className='clarificationClose' onClick={onClose}>&times;</button>
                    <h2>Clarification:</h2>
                    <p><strong>Highlighted Text:</strong> {highlightedText}</p>
                    {loadingAPI ? (
                        <p>Loading content...</p>
                    ) : error ? (
                        <p>{error}</p>
                    ) : (
                        <div className='clarification-content'>
                            <p><strong>Clarification:</strong> {clarification}</p>
                            <button onClick={onRefresh}>Refresh clarification</button>
                        </div>
                    )}
                </div>
            </div>
        </Popup>
    );
};

export default ClarificationPopup;